export const ssoLink = 'https://app.matchplat.com/sso';
export const explore = 'https://explore.matchplat.com';
export const getUri = () => {
    let uri = '';
    if (process.env.REACT_APP_URI_ENV === 'dev') {
        uri = 'https://api-test.matchplat.com/graphql/';
    }
    else if (process.env.REACT_APP_URI_ENV === 'test') {
        uri = 'https://api-test.matchplat.com/graphql/';
    }
    else if (process.env.REACT_APP_URI_ENV === 'prod') {
        uri = 'https://api.matchplat.com/graphql/';
    }
    return uri;
};
export const getAppUri = (appName) => {
    let uri = '';
    if (process.env.REACT_APP_URI_ENV === 'dev') {
        uri = `https://${appName}-test.matchplat.com/`;
    }
    else if (process.env.REACT_APP_URI_ENV === 'test') {
        uri = `https://${appName}-test.matchplat.com/`;
    }
    else if (process.env.REACT_APP_URI_ENV === 'prod') {
        uri = `https://${appName}.matchplat.com/`;
    }
    return uri;
};
export const getMapUri = () => {
    let uri = '';
    if (process.env.REACT_APP_URI_ENV === 'dev') {
        uri = 'https://maps-test.matchplat.com/';
    }
    else if (process.env.REACT_APP_URI_ENV === 'test') {
        uri = 'https://maps-test.matchplat.com/';
    }
    else if (process.env.REACT_APP_URI_ENV === 'prod') {
        uri = 'https://maps.matchplat.com/';
    }
    return uri;
};
